import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import {
  render_number,
  render_vnd_to_aud,
  render_vnd_to_usd,
} from "../../utils/tool";

export default function BoxTotal({ title, price }) {
  return (
    <Box
      sx={{
        padding: 2,
        flex: 1,
        borderRadius: "10px",
        backgroundColor: "#FFFDE7",
        border: "1px solid #FFF176",
        marginRight: 1,
        "&:last-child": { marginRight: 0 },
      }}
    >
      <Typography style={{ fontSize: 13, fontWeight: 600, color: "#666", marginBottom: 4 }}>
        {title}
      </Typography>
      <Typography style={{ fontSize: 16, fontWeight: 700 }}>
        {render_number(price)}
        {" VND"}
      </Typography>
      <Typography style={{ fontSize: 13, color: "#777" }}>
        {render_vnd_to_aud(price)}
        {" AUD"}
      </Typography>
      <Typography style={{ fontSize: 13, color: "#777" }}>
        {render_vnd_to_usd(price)}
        {" USD"}
      </Typography>
    </Box>
  );
}
